import { ICellRendererParams } from 'ag-grid-community';

import { ExpandableList } from 'core/components';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';

import { IExternalCustomerRow, MAX_DISPLAYED_PAIRED_PROJECTS } from './utils';

// Values can repeat (same name/number), so the position is the only unique key.
interface IPairedProjectValueItem {
  id: number;
  text: string;
}

export const PairedProjectValuesCell = ({
  value,
}: ICellRendererParams<IExternalCustomerRow, string[]>) => {
  if (!value?.length) {
    return <TextLine text={DEFAULT_PLACEHOLDER} />;
  }

  return (
    <ExpandableList<IPairedProjectValueItem>
      items={value.map((text, id) => ({ id, text }))}
      itemRenderer={(item: IPairedProjectValueItem) => <TextLine text={item.text} />}
      marker=""
      maxItems={MAX_DISPLAYED_PAIRED_PROJECTS}
    />
  );
};
